import { render, staticRenderFns } from "./BatchDetailsDialog.vue?vue&type=template&id=7fc4889a&scoped=true&"
import script from "./BatchDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./BatchDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchDetailsDialog.vue?vue&type=style&index=0&id=7fc4889a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc4889a",
  null
  
)

export default component.exports